import { db } from "../../firebase";
import { useState, useEffect } from "react";

const Add = () => {
  const [currentAd, setCurrentAd] = useState();

  useEffect(() => {
    const ref = db.collection("blogs/blog/AD");
    ref
      .orderBy("createdate", "desc")
      .limit(1)
      .get()
      .then((querySnapshot) => {
        let documents = [];
        querySnapshot.forEach((doc) => {
          documents.push({ ...doc.data(), id: doc.id });
        });
        setCurrentAd(documents);
      });
  }, []);
  return (
    <div className="ad-container">
      <div className="container">
        {currentAd ? (
          currentAd.map((ad) => {
            return (
              <div key={ad.id} className="ad">
                <img src={ad.file.src} alt="" />
                <div className="ad-titlee">
                  <a href={ad.url} target="_blank">
                    <div className="display-4">{ad.title}</div>
                  </a>
                </div>
              </div>
            );
          })
        ) : (
          <div className="skeleton ad"></div>
        )}
      </div>
    </div>
  );
};

export default Add;
